export default __webpack_public_path__ + "static/media/daze.389396a4.jpg";